import { storeToRefs } from 'pinia';
import { useAccountStore } from '~/stores/accountStore';
import { useMeilisearchStore } from '~/stores/meilisearchStore';

export default defineNuxtRouteMiddleware(async () => {
    if (process.client) return; 

    const accountStore = useAccountStore();
    const { tenantToken } = storeToRefs(useMeilisearchStore());
    
    if (!accountStore.state.id) return;
    
    const apiKey = process.env.MEILISEARCH_SEARCH_API_KEY;
    if (!apiKey) {
        return console.warn('Meilisearch API key not configured');
    }

    try {
        const { generateTenantToken } = await import('~/utils/tenantToken.server');
        const token = generateTenantToken(apiKey, accountStore.state.id, process.env.MEILISEARCH_SEARCH_API_KEY_UID || '');
        tenantToken.value = token;
    } catch (error) {
        console.error('Failed to generate Meilisearch tenant token:', error);
    }
}); 
